export default __webpack_public_path__ + "0429918c7e5bea319bcf95f3667c2dc3.png";